/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as AuthenticatedItemsImport } from './routes/_authenticated/items'
import { Route as AuthenticatedItemsShoppinglistImport } from './routes/_authenticated/items/shoppinglist'
import { Route as AuthenticatedItemsShoppinglistOptionsImport } from './routes/_authenticated/items/shoppinglist/options'
import { Route as AuthenticatedItemsListsItemTypeImport } from './routes/_authenticated/items/lists/$itemType'
import { Route as AuthenticatedItemsListsItemTypeChooseImport } from './routes/_authenticated/items/lists/$itemType/choose'
import { Route as AuthenticatedItemsListsItemTypeAddImport } from './routes/_authenticated/items/lists/$itemType/add'
import { Route as AuthenticatedItemsListsItemTypeItemIdImport } from './routes/_authenticated/items/lists/$itemType/$itemId'
import { Route as AuthenticatedItemsListsItemTypeChooseAddImport } from './routes/_authenticated/items/lists/$itemType/choose/add'

// Create/Update Routes

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedItemsRoute = AuthenticatedItemsImport.update({
  path: '/items',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedItemsShoppinglistRoute =
  AuthenticatedItemsShoppinglistImport.update({
    path: '/shoppinglist',
    getParentRoute: () => AuthenticatedItemsRoute,
  } as any)

const AuthenticatedItemsShoppinglistOptionsRoute =
  AuthenticatedItemsShoppinglistOptionsImport.update({
    path: '/options',
    getParentRoute: () => AuthenticatedItemsShoppinglistRoute,
  } as any)

const AuthenticatedItemsListsItemTypeRoute =
  AuthenticatedItemsListsItemTypeImport.update({
    path: '/lists/$itemType',
    getParentRoute: () => AuthenticatedItemsRoute,
  } as any)

const AuthenticatedItemsListsItemTypeChooseRoute =
  AuthenticatedItemsListsItemTypeChooseImport.update({
    path: '/choose',
    getParentRoute: () => AuthenticatedItemsListsItemTypeRoute,
  } as any)

const AuthenticatedItemsListsItemTypeAddRoute =
  AuthenticatedItemsListsItemTypeAddImport.update({
    path: '/add',
    getParentRoute: () => AuthenticatedItemsListsItemTypeRoute,
  } as any)

const AuthenticatedItemsListsItemTypeItemIdRoute =
  AuthenticatedItemsListsItemTypeItemIdImport.update({
    path: '/$itemId',
    getParentRoute: () => AuthenticatedItemsListsItemTypeRoute,
  } as any)

const AuthenticatedItemsListsItemTypeChooseAddRoute =
  AuthenticatedItemsListsItemTypeChooseAddImport.update({
    path: '/add',
    getParentRoute: () => AuthenticatedItemsListsItemTypeChooseRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/items': {
      id: '/_authenticated/items'
      path: '/items'
      fullPath: '/items'
      preLoaderRoute: typeof AuthenticatedItemsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/items/shoppinglist': {
      id: '/_authenticated/items/shoppinglist'
      path: '/shoppinglist'
      fullPath: '/items/shoppinglist'
      preLoaderRoute: typeof AuthenticatedItemsShoppinglistImport
      parentRoute: typeof AuthenticatedItemsImport
    }
    '/_authenticated/items/lists/$itemType': {
      id: '/_authenticated/items/lists/$itemType'
      path: '/lists/$itemType'
      fullPath: '/items/lists/$itemType'
      preLoaderRoute: typeof AuthenticatedItemsListsItemTypeImport
      parentRoute: typeof AuthenticatedItemsImport
    }
    '/_authenticated/items/shoppinglist/options': {
      id: '/_authenticated/items/shoppinglist/options'
      path: '/options'
      fullPath: '/items/shoppinglist/options'
      preLoaderRoute: typeof AuthenticatedItemsShoppinglistOptionsImport
      parentRoute: typeof AuthenticatedItemsShoppinglistImport
    }
    '/_authenticated/items/lists/$itemType/$itemId': {
      id: '/_authenticated/items/lists/$itemType/$itemId'
      path: '/$itemId'
      fullPath: '/items/lists/$itemType/$itemId'
      preLoaderRoute: typeof AuthenticatedItemsListsItemTypeItemIdImport
      parentRoute: typeof AuthenticatedItemsListsItemTypeImport
    }
    '/_authenticated/items/lists/$itemType/add': {
      id: '/_authenticated/items/lists/$itemType/add'
      path: '/add'
      fullPath: '/items/lists/$itemType/add'
      preLoaderRoute: typeof AuthenticatedItemsListsItemTypeAddImport
      parentRoute: typeof AuthenticatedItemsListsItemTypeImport
    }
    '/_authenticated/items/lists/$itemType/choose': {
      id: '/_authenticated/items/lists/$itemType/choose'
      path: '/choose'
      fullPath: '/items/lists/$itemType/choose'
      preLoaderRoute: typeof AuthenticatedItemsListsItemTypeChooseImport
      parentRoute: typeof AuthenticatedItemsListsItemTypeImport
    }
    '/_authenticated/items/lists/$itemType/choose/add': {
      id: '/_authenticated/items/lists/$itemType/choose/add'
      path: '/add'
      fullPath: '/items/lists/$itemType/choose/add'
      preLoaderRoute: typeof AuthenticatedItemsListsItemTypeChooseAddImport
      parentRoute: typeof AuthenticatedItemsListsItemTypeChooseImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AuthenticatedRoute: AuthenticatedRoute.addChildren({
    AuthenticatedItemsRoute: AuthenticatedItemsRoute.addChildren({
      AuthenticatedItemsShoppinglistRoute:
        AuthenticatedItemsShoppinglistRoute.addChildren({
          AuthenticatedItemsShoppinglistOptionsRoute,
        }),
      AuthenticatedItemsListsItemTypeRoute:
        AuthenticatedItemsListsItemTypeRoute.addChildren({
          AuthenticatedItemsListsItemTypeItemIdRoute,
          AuthenticatedItemsListsItemTypeAddRoute,
          AuthenticatedItemsListsItemTypeChooseRoute:
            AuthenticatedItemsListsItemTypeChooseRoute.addChildren({
              AuthenticatedItemsListsItemTypeChooseAddRoute,
            }),
        }),
    }),
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/items"
      ]
    },
    "/_authenticated/items": {
      "filePath": "_authenticated/items.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/items/shoppinglist",
        "/_authenticated/items/lists/$itemType"
      ]
    },
    "/_authenticated/items/shoppinglist": {
      "filePath": "_authenticated/items/shoppinglist.tsx",
      "parent": "/_authenticated/items",
      "children": [
        "/_authenticated/items/shoppinglist/options"
      ]
    },
    "/_authenticated/items/lists/$itemType": {
      "filePath": "_authenticated/items/lists/$itemType.tsx",
      "parent": "/_authenticated/items",
      "children": [
        "/_authenticated/items/lists/$itemType/$itemId",
        "/_authenticated/items/lists/$itemType/add",
        "/_authenticated/items/lists/$itemType/choose"
      ]
    },
    "/_authenticated/items/shoppinglist/options": {
      "filePath": "_authenticated/items/shoppinglist/options.tsx",
      "parent": "/_authenticated/items/shoppinglist"
    },
    "/_authenticated/items/lists/$itemType/$itemId": {
      "filePath": "_authenticated/items/lists/$itemType/$itemId.tsx",
      "parent": "/_authenticated/items/lists/$itemType"
    },
    "/_authenticated/items/lists/$itemType/add": {
      "filePath": "_authenticated/items/lists/$itemType/add.tsx",
      "parent": "/_authenticated/items/lists/$itemType"
    },
    "/_authenticated/items/lists/$itemType/choose": {
      "filePath": "_authenticated/items/lists/$itemType/choose.tsx",
      "parent": "/_authenticated/items/lists/$itemType",
      "children": [
        "/_authenticated/items/lists/$itemType/choose/add"
      ]
    },
    "/_authenticated/items/lists/$itemType/choose/add": {
      "filePath": "_authenticated/items/lists/$itemType/choose/add.tsx",
      "parent": "/_authenticated/items/lists/$itemType/choose"
    }
  }
}
ROUTE_MANIFEST_END */
